import React from 'react';
import { Typography, theme } from 'antd';

const { Text } = Typography;

interface AppointmentDetailRowProps {
  icon: React.ReactNode;
  label: string;
  children: React.ReactNode;
}

/**
 * Label/value row used in appointment details: a fixed-width muted label column and a value column.
 */
export function AppointmentDetailRow({ icon, label, children }: AppointmentDetailRowProps) {
  const { token } = theme.useToken();

  return (
    <div style={{ display: 'flex', gap: token.marginSM, alignItems: 'flex-start' }}>
      <div
        style={{
          width: 110,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          paddingTop: 1,
          color: token.colorTextSecondary,
          fontSize: token.fontSizeSM
        }}>
        {icon}
        <Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
          {label}
        </Text>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
    </div>
  );
}
